import { Controller } from '@hotwired/stimulus';

// Validates file input type client-side before form submission.
// Shows an inline error and disables the submit button if the selected
// file's MIME type is not in the allowedTypes list.
export default class extends Controller {
  static targets = ['input', 'error'];
  static values = {
    allowedTypes: Array,
    errorMessage: String,
  };

  connect() {
    this.submitButton = this.element.closest('form')?.querySelector('[type="submit"]');
  }

  validate() {
    const file = this.inputTarget.files[0];

    if (!file) {
      this.#hideError();
      this.#enableSubmit();
      return;
    }

    // Browsers often report no MIME type for HEIC/HEIF; don't block — the
    // server validates content type authoritatively.
    if (file.type === '') {
      this.#hideError();
      this.#enableSubmit();
      return;
    }

    if (!this.allowedTypesValue.includes(file.type)) {
      this.#showError();
      this.#disableSubmit();
      // Clear the invalid file so it cannot be submitted
      this.inputTarget.value = '';
    } else {
      this.#hideError();
      this.#enableSubmit();
    }
  }

  #showError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.remove('hidden');
    }
  }

  #hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('hidden');
    }
  }

  #disableSubmit() {
    if (this.submitButton) {
      this.submitButton.disabled = true;
      this.submitButton.classList.add('opacity-50', 'cursor-not-allowed');
    }
  }

  #enableSubmit() {
    if (this.submitButton) {
      this.submitButton.disabled = false;
      this.submitButton.classList.remove('opacity-50', 'cursor-not-allowed');
    }
  }
}
